import './ServiceCard.css';
import { Link } from 'react-router-dom';
import {
  FaAmbulance,
  FaBriefcaseMedical,
  FaHandshake,
  FaHospital,
  FaLaptopMedical,
  FaPlaneDeparture,
  FaRoute,
  FaVial,
} from 'react-icons/fa';

const icons = {
  ambulance: FaAmbulance,
  courier: FaRoute,
  health_tech: FaBriefcaseMedical,
  it: FaLaptopMedical,
  management: FaHospital,
  pathology: FaVial,
  tourism: FaPlaneDeparture,
  tpa: FaHandshake,
};

function ServiceCard({ service }) {
  const Icon = icons[service.service_type] || FaBriefcaseMedical;

  return (
    <div className="service-card">
      {service.icon ? (
        <img src={service.icon} alt={service.name} className="service-icon" />
      ) : (
        <span className="service-icon-fallback" aria-hidden="true">
          <Icon />
        </span>
      )}
      <h3>{service.name}</h3>
      <p className="service-type">{service.service_type.replace(/_/g, ' ').toUpperCase()}</p>
      <p>{service.description}</p>
      <Link to="/contact" className="learn-more">Enquire Now</Link>
    </div>
  );
}

export default ServiceCard;
